import { DispatchBoardQueueLoad, DispatchBoardQueueStatus } from "app/data/city-delivery/dispatch-board/models";
import React, { memo } from "react";
import SlideOutSidebar from "ui-components/slide-out-sidebar/slideOutSidebar";
import SteppedProgress, { SteppedProgressStep } from "ui-components/stepped-progress/steppedProgress";

export interface CityDeliveryDispatchWorkflowProps {
    dispatchLoad: DispatchBoardQueueLoad,
    onClose: () => void
}

const CityDeliveryDispatchWorkflow: React.FC<CityDeliveryDispatchWorkflowProps> = memo((props) => {

    const generateProgressSteps = (dispatchLoadStatus: DispatchBoardQueueStatus): SteppedProgressStep[] => {
        const statusSteps = [
            {
                dispatchLoadStatus: DispatchBoardQueueStatus.READY_TO_ASSIGN,
                title: "Ready to Assign"
            },
            {
                dispatchLoadStatus: DispatchBoardQueueStatus.LOADING,
                title: "Loading"
            },
            {
                dispatchLoadStatus: DispatchBoardQueueStatus.READY_TO_CLOSE,
                title: "Ready to Close"
            },
            {
                dispatchLoadStatus: DispatchBoardQueueStatus.READY_TO_DISPATCH,
                title: "Ready to Dispatch"
            },
            {
                dispatchLoadStatus: DispatchBoardQueueStatus.DISPATCHED,
                title: "Dispatched"
            },
            {
                dispatchLoadStatus: null,
                title: "Docs"
            },
        ];

        let completedStepIndex = statusSteps.findIndex(step => step.dispatchLoadStatus === dispatchLoadStatus);
        return statusSteps.map((step: any, stepIndex: number) => {
            return ({
                title: step.title,
                reached: (stepIndex <= completedStepIndex) ?  true : false,
                completed: (stepIndex < completedStepIndex) ? true : false,
            });
        });
    }

return (
    <SlideOutSidebar
        header={`Load Details`}
        onClose={props.onClose}
        size="medium"
        show={true}
    >
        <div>
            <div>Workflow Progress</div>
            <SteppedProgress
                steps={generateProgressSteps(props.dispatchLoad.status)}
            />
        </div>
    </SlideOutSidebar>
);
});

export default CityDeliveryDispatchWorkflow;
